<template>
  <div>
    <div class="form__row signup-optin">
      <input type="hidden" name="fields[stockistConsentOptIn]" value="0">
      <input id="stockistConsentOptIn" v-model="optIn" type="checkbox" name="fields[stockistConsentOptIn]" value="1" @change="optInChange">
      <label for="stockistConsentOptIn">I would like my local stockist to contact me</label>
    </div>
   
    <div v-if="optIn">
      <div v-if="showPostcodeMissing" class="form__row">
        <p class="error">Please ensure you have entered a valid postcode.</p>
      </div>
      <div v-else>
        <div class="form__row">
          <p>Your query will be sent to your nearest {{ currentSite.name }}{{ (currentSite.handle != 'default')? ' Bathrooms' : '' }} showroom, please provide as much information as possible and they will be in touch to arrange an appointment shortly.</p>
        </div>
        <div v-show="stockists.length > 0">
          <div class="form__row">
            <select id="bookingViewing_stockist" ref="stockistSelect" v-model="selectedStockistId" name="stockistId">
              <option value="0">Select a Stockist</option>
              <option v-for="item in stockists" :key="item.id" :value="item.id">{{ item.title }}</option>
            </select>
            <input type="hidden" name="fields[selectedStockist]" :value="stockist">
          </div>
        </div>
        <div v-if="selectedStockistId != 0">
          <div class="form__row">
            <input id="form-input-stockist-subject" v-model="subject" name="fields[stockistSubject]" type="text" placeholder="Subject" autocomplete="off" required>
          </div>
          <div class="form__row">
            <textarea id="form-input-stockist-message" v-model="message" name="fields[stockistMessage]" placeholder="Message" autocomplete="off" required />
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../config/axios";

export default {
	props: {
		consent: {
			type: Boolean,
			default: false
		},
    currentSite: {
      type: Object,
      default: null,
      require: true
    },
    selectedStockist: {
      type: Number,
      default: 0,
      require: true
    },
    stockistSubject: {
      type: String,
      default: ''
    },
    stockistMessage: {
      type: String,
      default: ''
    }
  },
  data() {
		return {
			optIn: this.consent,
      showPostcodeMissing: false,
      stockists: [],
      selectedStockistId: this.selectedStockist,
      stockistsDropDown: null,
      subject: this.stockistSubject,
      message: this.stockistMessage,
      postcode: ''
		};
	}, 
  computed: {
    stockist() {
      if(this.selectedStockistId) {
          const selectedStockist = this.stockists.filter(stockist => stockist.id === this.selectedStockistId)[0] ?? null;

          if(selectedStockist) {
              return `${selectedStockist.title} | ${selectedStockist.id} | ${selectedStockist.accountNumber}`;
          }
      }

      return '';
    }
  },
  mounted() {
    this.$root.$refs.registerButton.disabled = true;

    if(this.consent) {
      this.checkPostcodePopulated();
    }
    if(this.selectedStockistId !== 0) {
      this.findStockists();
    }

    const component = this;

    window.recaptchaChecked = function() {
      component.$root.$refs.registerButton.disabled = false;
    };

    window.pca.on("load", function(type, id, control) {
      control.listen("populate", component.findStockists);
    });
  },

  methods: {
    optInChange: function(value) {
      if(!value) {
        return;
      }
     
      this.checkPostcodePopulated();
      if(!this.showPostcodeMissing && this.stockists.length < 1) {
        this.findStockists();
      }
    },
    postcodeChange() {
      this.postcode = this.$root.$refs.customerPostcode.value;
      if(this.$root.$refs.customerPostcode.value.length < 3) {
        this.showPostcodeMissing = true;
        this.resetFields();
      }
    },
    async findStockists() {
      // We need a post code and a country code to do a search
      if (!(this.$root.$refs.customerPostcode.value && this.$root.$refs.customerCountry.value)) {
        this.showPostcodeMissing = true;
        return;
      }

      this.resetFields();

      const formData = {
          postcode: this.$root.$refs.customerPostcode.value,
          countrycode: this.$root.$refs.customerCountry.value,
      };

      const response = await axios.post('/actions/nearest-stockist/search/by-postcode', formData);

      if (response.data.success) {
          this.stockists = [...response.data.stockists];

          if(this.stockists.length > 0) {
            this.showPostcodeMissing = false;
            this.$nextTick(() => {
              if(this.$refs.stockistSelect) {
                this.$refs.stockistSelect.focus();
              }
          });
        }  
      }
    },
    checkPostcodePopulated() {
      this.showPostcodeMissing = !(this.$root.$refs.customerPostcode.value.length > 0);
    },
    resetFields() {
      this.selectedStockistId = 0;
      this.message = '';
      this.subject = '';
    }
  }
}
</script>